// import 'react-aspect-ratio/aspect-ratio.css';
import { Box, Skeleton } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { ResizableCard } from '../resizable-card';
import { Content } from './challenge-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingCard = function LoadingCard() {
  return /*#__PURE__*/_jsx(ReactAspectRatio, {
    ratio: "0.95",
    "data-element": "ReactAspectRatio",
    "data-component": "LoadingCard",
    "data-source-file": "loading-card.tsx",
    children: /*#__PURE__*/_jsxs(ResizableCard, {
      sx: {
        minWidth: '230px',
        minHeight: '241px'
      },
      "data-element": "ResizableCard",
      "data-component": "LoadingCard",
      "data-source-file": "loading-card.tsx",
      children: [/*#__PURE__*/_jsx(ReactAspectRatio, {
        ratio: "1.78",
        "data-element": "ReactAspectRatio",
        "data-component": "LoadingCard",
        "data-source-file": "loading-card.tsx",
        children: /*#__PURE__*/_jsx(Skeleton, {
          variant: "rectangular",
          width: "100%",
          height: "100%",
          "data-element": "Skeleton",
          "data-component": "LoadingCard",
          "data-source-file": "loading-card.tsx"
        })
      }), /*#__PURE__*/_jsx(Content, {
        "data-element": "Content",
        "data-source-file": "loading-card.tsx",
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            maxHeight: 56
          },
          "data-element": "Box",
          "data-source-file": "loading-card.tsx",
          children: /*#__PURE__*/_jsxs(Box, {
            sx: {
              maxWidth: '70%'
            },
            "data-element": "Box",
            "data-source-file": "loading-card.tsx",
            children: [/*#__PURE__*/_jsx(Skeleton, {
              variant: "text",
              sx: {
                mt: 0.5,
                mb: 0.25
              },
              height: 16,
              width: 60,
              "data-element": "Skeleton",
              "data-source-file": "loading-card.tsx"
            }), /*#__PURE__*/_jsx(Skeleton, {
              variant: "text",
              width: 120,
              height: 32,
              "data-element": "Skeleton",
              "data-source-file": "loading-card.tsx"
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          pl: 2,
          pb: 1,
          position: 'absolute',
          bottom: '0'
        },
        "data-element": "Box",
        "data-source-file": "loading-card.tsx",
        children: /*#__PURE__*/_jsx(Skeleton, {
          variant: "text",
          width: 40,
          "data-element": "Skeleton",
          "data-source-file": "loading-card.tsx"
        })
      })]
    })
  });
};

export default LoadingCard;